import {createFileRoute} from '@tanstack/react-router';
import {
  ErrorDescriptionParameter,
  LoginErrorPage,
} from 'pages/error/LoginErrorPage';

export const Route = createFileRoute('/login/error')({
  component: LoginErrorPage,
  validateSearch: (search) => {
    return {
      error: search.error as string | undefined,
      error_description: search.error_description as
        | ErrorDescriptionParameter
        | undefined,
    };
  },
});
